import script from "./Left_AsideSm.vue?vue&type=script&setup=true&lang=js"
export * from "./Left_AsideSm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__